import 'script-loader!jquery';

import 'script-loader!foundation-sites/dist/js/plugins/foundation.core';
import 'foundation-sites/dist/js/plugins/foundation.util.mediaQuery';
import 'foundation-sites/dist/js/plugins/foundation.util.keyboard';
import 'foundation-sites/dist/js/plugins/foundation.util.box';
import 'foundation-sites/dist/js/plugins/foundation.util.triggers';
import 'foundation-sites/dist/js/plugins/foundation.offcanvas';
import 'foundation-sites/dist/js/plugins/foundation.dropdown';

import 'isotope-layout/dist/isotope.pkgd.min';
import 'flatpickr';
var Flickity = require('flickity');
import 'imgix.js';

import 'angular';
import 'ui-select';


// WEBPACK FOOTER //
// ./frontend/storefront/storefront-vendor.js